"use strict";

var fromArray = exports.fromArray = function (array) {
  var index = 0;
  var hasNext = function hasNext() {
    return index < array.length;
  };
  return new LazyIterator({
    hasNext: hasNext,
    next: function next() {
      if (!hasNext()) {
        throw new Error("No more elements");
      } else {
        return array[index++];
      }
    }
  });
};
var LazyIterator = function LazyIterator(iterator) {
  this._iterator = iterator;
};
LazyIterator.prototype.map = function (func) {
  var iterator = this._iterator;
  return new LazyIterator({
    hasNext: function hasNext() {
      return iterator.hasNext();
    },
    next: function next() {
      return func(iterator.next());
    }
  });
};
LazyIterator.prototype.filter = function (condition) {
  var iterator = this._iterator;
  var moved = false;
  var _hasNext = false;
  var _next;
  var moveIfNecessary = function moveIfNecessary() {
    if (moved) {
      return;
    }
    moved = true;
    _hasNext = false;
    while (iterator.hasNext() && !_hasNext) {
      _next = iterator.next();
      _hasNext = condition(_next);
    }
  };
  return new LazyIterator({
    hasNext: function hasNext() {
      moveIfNecessary();
      return _hasNext;
    },
    next: function next() {
      moveIfNecessary();
      var toReturn = _next;
      moved = false;
      return toReturn;
    }
  });
};
LazyIterator.prototype.first = function () {
  var iterator = this._iterator;
  if (this._iterator.hasNext()) {
    return iterator.next();
  } else {
    return null;
  }
};
LazyIterator.prototype.toArray = function () {
  var result = [];
  while (this._iterator.hasNext()) {
    result.push(this._iterator.next());
  }
  return result;
};